module.exports = __webpack_public_path__ + "img/1F4E8.16d9cd13.svg";